import { type RecType } from '@/defs/rec'

import { StatCommonBox } from '../../StatCommon/StatCommonBox/StatCommonBox'
import { StatCommonDonutPercentage } from '../../StatCommon/StatCommonDonutPercentage/StatCommonDonutPercentage'
import { StatRecInclusionTooltip } from '../StatRecInclusionTooltip/StatRecInclusionTooltip'

type Props = {
  isInView?: boolean
  rec: RecType
}

export const StatRecInclusionGraphic = ({ isInView, rec }: Props) => (
  <StatCommonBox isInView={isInView} label='Inclusion' popover={<StatRecInclusionTooltip rec={rec} />}>
    <StatCommonDonutPercentage percentage={rec.inclusion} />
  </StatCommonBox>
)
